import $ from '@ali/tarzan-zepto';

import ATpl from './templates/index.html';
import MsgParentTpl from './templates/msg.html';
import panelMsgTpl from './templates/panelMsg.html';
import slideupTpl from './templates/slideup.html';
import sliderTpl from './templates/slider.html';
import OrderItem from './templates/orderItem.html';
import popupTpl from './templates/popup.html';

/**
 * 上一条消息在哪边
 */
// let lastSide = null;

const Template = {
  /**
   * 气泡里是否显示头像
   */
  showAvatar: false,

  frame: (data) => {
    const $node = ATpl.render(data);
    return $node;
  },

  msg: (data) => {
    // 没传默认在左边
    const side = data.side || 'left';
    data.side = side;
    const node = MsgParentTpl.render(data);
    return node;
  },

  slideUp: (data) => {
    $('.m-card-popup-rar_list').remove();
    const $node = slideupTpl.render(data);
    return $node;
  },

  slider: (data) => {
    const $node = sliderTpl.render(data);
    return $node;
  },

  orderItem: (data) => {
    data.id = data.parentId || data.id;
    if (data.tradeTime) {
      data.type = 'order';
    } else {
      data.type = 'item';
    }
    const $node = OrderItem.render(data);
    return $node;
  },

  popup: (data) => {
    const $node = popupTpl.render(data);
    return $node;
  },

  panelMsg: (data) => {
    const side = data.side || 'left';
    data.side = side;
    const node = panelMsgTpl.render(data);
    return node;
  },
};

export default Template;



// WEBPACK FOOTER //
// ./src/component/baseui/index.js